import React from "react";
import CruiseWizardPage from "@/pages/Cruise/CruiseWizardPage";
import {ApiProvider, PageRouteProvider} from "@reapptor-apps/reapptor-react-common";
import CreateCruiseOrderRequest from "@/models/server/requests/CreateCruiseOrderRequest";
import PageDefinitions from "@/providers/PageDefinitions";
import Localizer from "@/localization/Localizer";

import styles from "./Summary.module.scss";

import logo from "./images/logo.png";

export interface ISummaryProps {
}

interface ISummaryState {
}

export default class Summary extends CruiseWizardPage<ISummaryProps, ISummaryState> {

    state: ISummaryState = {
    };

    public get navigation(): boolean {
        return false;
    }
    
    public async initializeAsync(): Promise<void> {

        if ((this.wizard.country) && (!this.wizard.completed) && (!this.wizard.sending)) {
            const request = new CreateCruiseOrderRequest();
            request.countryCode = this.wizard.country!.code!;
            request.areaId = this.wizard.area ? this.wizard.area.id : null;
            request.customArea = this.wizard.customArea;
            request.departBy = this.wizard.departBy ?? new Date();
            request.departFrom = this.wizard.departFrom;
            request.visitPoint = this.wizard.visitPoint;
            request.visitingPointDuration = this.wizard.visitingPointDuration;
            request.arriveAt = this.wizard.arriveAt ?? new Date();
            request.arriveTo = this.wizard.arriveTo;
            request.groupSize = this.wizard.groupSize!;
            request.timeOfDay = this.wizard.timeOfDay!;
            request.duration = this.wizard.duration!;
            request.date = this.wizard.date;
            request.extras = this.wizard.extras;
            request.groupSizeValue = this.wizard.groupSizeValue;
            request.childrenComing = this.wizard.childrenComing;
            request.numberOfComingChildren = this.wizard.numberOfComingChildren;
            request.accessibilityLimitations = this.wizard.accessibilityLimitations;
            request.accessibilityLimitationsComment = this.wizard.accessibilityLimitationsComment;
            request.estimatedPrice = this.wizard.estimatedPrice;
            request.comment = this.wizard.comment;
            request.name = this.wizard.name;
            request.company = this.wizard.company;
            request.email = this.wizard.email;
            request.phone = this.wizard.phone;
            request.agreementAccepted = this.wizard.agreementAccepted;
            request.registrationAccepted = this.wizard.registrationAccepted;
            request.cancellationPolicyAccepted = this.wizard.cancellationPolicyAccepted;

            this.wizard.sending = true;
            this.saveContext();

            try {
                
                await ApiProvider.postAsync("api/cruise/createCruiseOrder", request);

                this.wizard.completed = true;
                this.saveContext();
            } finally {
                this.wizard.sending = false;
                this.saveContext();
            }
        }
    }
    
    public async prevAsync(): Promise<void> {
        await PageRouteProvider.redirectAsync(PageDefinitions.cruiseWizardCountryRoute);
    }

    public renderContent(): React.ReactNode {
        return (
            <div className={styles.contacts}>

                <p>{Localizer.cruiseWizardWeWillSendYou}</p>
                
                <img src={logo} alt={"logo"} />

            </div>
        );
    }
}